import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getAllUsageManualsAsync, getLatestUsageManualAsync, getNextVersionAsync, replaceUsageManualFileAsync, uploadUsageManualAsync } from './usageManualThunk';
const initialState = {
    status: APIStatus.IDLE,
    manuals: [],
    latest: null,
    nextVersion: '0.0.1',
    uploadStatus: APIStatus.IDLE
};
export const usageManualSlice = createSlice({
    name: 'usageManual',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllUsageManualsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllUsageManualsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.manuals = action.payload;
        })
            .addCase(getAllUsageManualsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getLatestUsageManualAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getLatestUsageManualAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.latest = action.payload;
        })
            .addCase(getLatestUsageManualAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(getNextVersionAsync.fulfilled, (state, action) => {
            state.nextVersion = action.payload;
        })
            .addCase(uploadUsageManualAsync.pending, (state) => {
            state.uploadStatus = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(uploadUsageManualAsync.fulfilled, (state, action) => {
            state.uploadStatus = APIStatus.SUCCESS;
            // Insert the new record; mark others as non-latest only if this is a new version
            const newDto = action.payload;
            const existingForSameVersion = state.manuals.some((m) => m.versionLabel === newDto.versionLabel && m.id !== newDto.id);
            if (existingForSameVersion) {
                // Adding a language to existing version — just append
                state.manuals = [newDto, ...state.manuals];
            }
            else {
                // New version — mark all others non-latest
                state.manuals = [newDto, ...state.manuals.map((m) => ({ ...m, isLatest: false }))];
            }
            state.latest = newDto;
        })
            .addCase(uploadUsageManualAsync.rejected, (state, action) => {
            state.uploadStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            .addCase(replaceUsageManualFileAsync.pending, (state) => {
            state.uploadStatus = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(replaceUsageManualFileAsync.fulfilled, (state, action) => {
            state.uploadStatus = APIStatus.SUCCESS;
            // Replace the updated record in the list, keeping everything else unchanged
            state.manuals = state.manuals.map((m) => m.id === action.payload.id ? action.payload : m);
        })
            .addCase(replaceUsageManualFileAsync.rejected, (state, action) => {
            state.uploadStatus = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default usageManualSlice.reducer;
